/* ISAKIDS — JS de bază */
(function () {
  'use strict';

  /* ---------- Reveal la scroll ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window) || !els.length) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { obs.observe(el); });
  }

  /* ---------- Meniu mobil ---------- */
  function initMobileMenu() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var drawer = document.querySelector('[data-menu-drawer]');
    var overlay = document.querySelector('[data-menu-overlay]');
    var closeBtn = document.querySelector('[data-menu-close]');
    if (!toggle || !drawer) return;

    function open() {
      drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    toggle.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (overlay) overlay.addEventListener('click', close);

    // Submeniu mobil expand
    drawer.querySelectorAll('[data-submenu-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var parent = btn.closest('[data-menu-item]');
        if (parent) parent.classList.toggle('is-expanded');
      });
    });
  }

  /* ---------- Drawer coș ---------- */
 function initCartDrawer() {
  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  function open(e) {
    if (e) e.preventDefault();
    drawer.classList.add('is-open');
    var overlay = document.querySelector('[data-cart-overlay]');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    drawer.classList.remove('is-open');
    var overlay = document.querySelector('[data-cart-overlay]');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { open(e); }
    if (e.target.closest('[data-cart-close]')) { close(); }
    if (e.target.closest('[data-cart-overlay]')) { close(); }
  });
}

  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quick-add]');
      if (!btn) return;
      e.preventDefault();
      var id = btn.getAttribute('data-variant-id');
      if (!id) return;
      var original = btn.textContent;
      btn.textContent = '...';
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          btn.textContent = '✓ Adăugat';
          refreshCartCount();
          var drawer = document.querySelector('[data-cart-drawer]');
          if (drawer) { fetchCartDrawer(); }
          setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1600);
        })
        .catch(function () { btn.textContent = original; btn.disabled = false; });
    });
  }

  function fetchCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    fetch('/?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer-content]');
        var current = drawer.querySelector('[data-cart-drawer-content]');
        if (fresh && current) {
          current.innerHTML = fresh.innerHTML;
          drawer.classList.add('is-open');
          var overlay = document.querySelector('[data-cart-overlay]');
          if (overlay) overlay.classList.add('is-open');
          document.body.style.overflow = 'hidden';
        }
      });
  }

  /* ---------- Init ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initMobileMenu();
    initCartDrawer();
    initQuickAdd();
  });
})();
